module.exports = "/img/_/_/_/assets/images/creeper/battle/common//13.jpg?4df239a5a5855fadb346c1194596269a";